import { createRouter, createWebHistory } from "vue-router";

// REQ-CD-P1-CON-01 — five routes. Route-level code splitting per view
// (Performance & motion guidance): each view's chunk loads only when its
// route is visited.
const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", name: "status", component: () => import("@/views/StatusView.vue") },
    { path: "/assets", name: "assets", component: () => import("@/views/AssetsView.vue") },
    { path: "/incidents", name: "incidents", component: () => import("@/views/IncidentsView.vue") },
    { path: "/proposals", name: "proposals", component: () => import("@/views/ProposalsView.vue") },
    { path: "/control", name: "control", component: () => import("@/views/ControlView.vue") },
  ],
});

export default router;
